import type { Module } from 'vuex'
import type { RootState } from '@/store'
import type { SubscriptionsState } from './types'
import { SUBSCRIPTIONS_ACTIONS, SUBSCRIPTIONS_GETTERS } from './types'
import { subscriptionNames } from './utils'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'

const subscriptions: Module<SubscriptionsState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export { SUBSCRIPTIONS_ACTIONS, SUBSCRIPTIONS_GETTERS, subscriptionNames }
export type { SubscriptionsState }
export default subscriptions
